import { useEffect, useState } from 'react';

import { Button } from 'shadcn/components/ui/Button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from 'shadcn/components/ui/Dialog';
import { Input } from 'shadcn/components/ui/Input';

function UploadProductCSVDialog({ carouselID, isOpen, onClose, onConfirm }) {
    const [file, setFile] = useState(null);
    const [exampleCSVUrl, setExampleCSVUrl] = useState(null);

    useEffect(() => {
        const EXAMPLE_CSV_DATA = [
            ['Carousel ID', 'Rank', 'External SKU'],
            ['17903', '', '114222'],
            ['17903', '3', '121004'],
            ['17903', '1', '114449'],
            ['17903', '', '119332'],
            ['17903', '2', '120157'],
            ['17906', '', '114449'],
            ['17906', '1', '118796'],
        ];

        const csvContent = EXAMPLE_CSV_DATA.map((row) => row.join(',')).join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        setExampleCSVUrl(url);

        return () => URL.revokeObjectURL(url);
    }, []);

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Upload Product CSV</DialogTitle>
                    <DialogDescription>
                        Are you sure you want to upload a CSV of products for this configuration? This will overwrite
                        all existing products for{' '}
                        {carouselID ? <span className="font-bold">carousel (ID: {carouselID})</span> : 'all carousels'}.
                        <br />
                        <br />
                        You will need the configuration&apos;s carousel IDs to build a product CSV.{' '}
                        <a
                            href={exampleCSVUrl}
                            download="storefront-config-example.csv"
                            className="text-primary! underline"
                        >
                            Download an example file.
                        </a>
                    </DialogDescription>
                </DialogHeader>
                <Input
                    className="hover:bg-muted hover:cursor-pointer"
                    type="file"
                    accept=".csv"
                    onChange={(e) => setFile(e.target.files?.[0])}
                />
                <DialogFooter>
                    <Button variant="outline" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button variant="default" onClick={() => onConfirm(file)}>
                        Confirm
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default UploadProductCSVDialog;
